import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface SiteSettings {
  site_name: string;
  site_logo_url: string;
  contact_email: string;
  social_twitter: string;
  social_instagram: string;
  social_facebook: string;
  social_youtube: string;
  social_tiktok: string;
  social_linkedin: string;
}

const DEFAULT_SETTINGS: SiteSettings = {
  site_name: 'Wopfy',
  site_logo_url: '',
  contact_email: '',
  social_twitter: '',
  social_instagram: '',
  social_facebook: '',
  social_youtube: '',
  social_tiktok: '',
  social_linkedin: '',
};

export function useSiteSettings() {
  const [settings, setSettings] = useState<SiteSettings>(DEFAULT_SETTINGS);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const { data, error } = await supabase
        .from('site_settings')
        .select('setting_key, setting_value');
      if (!error && data) {
        const mapped: Record<string, string> = {};
        data.forEach((row: any) => {
          mapped[row.setting_key] = row.setting_value;
        });
        setSettings({
          site_name: mapped.site_name || DEFAULT_SETTINGS.site_name,
          site_logo_url: mapped.site_logo_url || DEFAULT_SETTINGS.site_logo_url,
          contact_email: mapped.contact_email || DEFAULT_SETTINGS.contact_email,
          social_twitter: mapped.social_twitter || '',
          social_instagram: mapped.social_instagram || '',
          social_facebook: mapped.social_facebook || '',
          social_youtube: mapped.social_youtube || '',
          social_tiktok: mapped.social_tiktok || '',
          social_linkedin: mapped.social_linkedin || '',
        });
      }
    } catch {
      // use defaults
    } finally {
      setLoading(false);
    }
  };

  return { settings, loading, refetch: fetchSettings };
}
